import React from 'react';
import { Link } from 'react-router-dom';

const plans = [
  {
    name: 'Essential Care',
    text: 'Updates, offsite backups, monitoring, and a monthly care note for a standard business website.',
    points: [
      'WordPress, plugin, and theme updates',
      'Offsite backups',
      'Uptime, SSL, and DNS monitoring',
      'A written monthly care note'
    ]
  },
  {
    name: 'Managed Care',
    text: 'The same foundation, plus included support time and someone who already knows the setup.',
    points: [
      'Everything in Essential Care',
      'Included support time each month',
      'Security hardening',
      'Help when something in the setup misbehaves'
    ]
  },
  {
    name: 'Advanced Care',
    text: 'More hands-on time for WooCommerce, membership, or a site that needs staging and closer watch.',
    points: [
      'Everything in Managed Care',
      'More included support time',
      'Checkout and form checks',
      'Staging site management'
    ]
  }
];

const BusinessPlans = () => {
  return (
    <section className="bg-white py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-16 max-w-3xl">
          <div className="mb-5 text-xs font-bold uppercase tracking-[0.2em] text-[#3B7C6D]">
            Monthly care
          </div>
          <h2 className="text-4xl leading-tight sm:text-5xl">
            Three levels. Same owner.
          </h2>
          <p className="mt-6 max-w-2xl text-xl leading-relaxed text-[#17211E]/70">
            Businesses use the same Essential, Managed, and Advanced Care
            work as agencies. Send the site for a Digital Review. We
            recommend a level and quote from there. Agency partner rates
            start at $59 per site.
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-3">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className="flex flex-col border border-[#17211E]/15 bg-[#FAF8F3] p-8 sm:p-10"
            >
              <h3 className="text-3xl leading-tight">{plan.name}</h3>
              <p className="mt-5 text-lg leading-relaxed text-[#17211E]/70">
                {plan.text}
              </p>
              <ul className="mt-8 flex-grow space-y-3 border-t border-[#17211E]/15 pt-7 text-base text-[#17211E]/80">
                {plan.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
              <Link
                to={`/get-started?plan=${encodeURIComponent(plan.name)}`}
                className="home-link mt-8 inline-block"
              >
                Get started
              </Link>
            </div>
          ))}
        </div>

        <p className="mt-10 text-lg text-[#17211E]/65">
          Not sure which level?{' '}
          <Link to="/digital-review" className="home-link text-lg">
            Request a Digital Review
          </Link>
          . Agencies use the same work behind their brand.{' '}
          <Link to="/agency-plans" className="home-link text-lg">
            See agency plans
          </Link>
        </p>
      </div>
    </section>
  );
};

export default BusinessPlans;
